
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.361 1.298a2.827 2.827 0 00-3.75-.943 2.816 2.816 0 00-1.106 1.106L.234 14.187l-.065.171c-.514 1.487.183 3.038 1.576 3.605l.223.08c.225.07.458.111.694.124l.083-.002.032.003h14.482l.176-.014c1.51-.167 2.62-1.456 2.543-2.958a2.836 2.836 0 00-.207-.922L12.453 1.451l-.09-.153zm-3.025.37a1.329 1.329 0 011.809.518l7.282 12.745.021.098c.013.067.027.156.032.247a1.33 1.33 0 01-1.26 1.393H2.747l-.151-.016a1.33 1.33 0 01-1.016-1.812L8.813 2.195l.082-.13c.117-.167.267-.3.441-.396zM9.231 13.27c0-.414.336-.756.75-.756s.75.331.75.745v.011a.75.75 0 01-1.5 0zm1.483-6.075a.75.75 0 00-1.493.102v3.1l.007.101a.75.75 0 001.493-.101v-3.1l-.007-.102z","fill":"#FF0C0C"}})])
          )
        }
      }
    